module.exports = __webpack_public_path__ + "img/banner_nat.81fed426.webp";